import React from 'react';
import classNames from 'classnames';
import { resolveId } from '@wix/communities-blog-client-common';
import { type NormalizedPost } from '@app/external/common/types';
import { type LayoutConfigListComponentProps } from './layout-config-component-props';
import styles from './post-list.scss';

const PostListMobile: React.FC<LayoutConfigListComponentProps> = (props) => {
  return (
    <div data-hook="post-list">
      {props.posts.map((post, index) => {
        const isLast = index === props.posts.length - 1;
        return (
          <PostListMobileItem
            key={post.id}
            post={post}
            index={index}
            isLast={isLast}
            ItemComponent={props.ItemComponent}
            itemConfig={props.itemConfig}
            type={props.type}
          />
        );
      })}
    </div>
  );
};

type ItemProps = {
  post: NormalizedPost;
  index: number;
  isLast: boolean;
} & Pick<LayoutConfigListComponentProps, 'ItemComponent' | 'itemConfig' | 'type'>;

const PostListMobileItem: React.FC<ItemProps> = ({
  post,
  type,
  ItemComponent,
  itemConfig,
  index,
  isLast,
}) => {
  const wrapperClass = classNames(styles.listItemMobile, 'post-list__post-list-item');
  const postId = resolveId(post);

  return (
    <div className={wrapperClass} key={postId} id={postId} data-id={postId}>
      <ItemComponent
        index={index}
        isLast={isLast}
        type={type}
        post={post}
        itemConfig={itemConfig}
      />
    </div>
  );
};

export default PostListMobile;
